module.exports = __webpack_public_path__ + "img/cup_pt_rnd_setsku.prt.75c635fe.jpg";